// extracted by mini-css-extract-plugin
export default {"inputs":"inputs-khVMK","repeatsInput":"repeatsInput-KJ4Ao"};